import { Component } from '@angular/core';
import { HelperService } from '../../helper/helper.service';
import { TranslatesService } from '../../helper/translate/translate.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.css']
})
export class MobileMenuComponent extends HelperService {
  constructor(
    public _translatesService: TranslatesService,
    private translate: TranslateService,
  ) {
    super();
  }

  changeLanguage(code: any): void {
    this._translatesService.changeLang(code);
    this.translate.use(code);
  }
}
